module.exports = __webpack_public_path__ + "img/personal-app-bg.7ad5ed3a.svg";